import { useId, useState } from "react";
import { createPortal } from "react-dom";

const CdesTooltip = ({ label, children }) => {
    const tooltipId = useId();
    const [anchor, setAnchor] = useState(null);
    const [position, setPosition] = useState(null);

    const show = (element) => {
        const rect = element.getBoundingClientRect();
        setPosition({ top: rect.top, left: rect.left + rect.width / 2 });
    };

    const hide = () => setPosition(null);

    return (
        <span
            className="cdes-tooltip"
            ref={setAnchor}
            onMouseOver={() => anchor && show(anchor)}
            onMouseOut={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) hide();
            }}
            onFocus={() => anchor && show(anchor)}
            onBlur={hide}
        >
            {children}
            {position
                ? createPortal(
                      <span id={tooltipId} className="cdes-tooltip__bubble" role="tooltip" style={{ top: position.top, left: position.left }}>
                          {label}
                      </span>,
                      document.body,
                  )
                : null}
        </span>
    );
};

export default CdesTooltip;
